import { PeekdataError } from 'peekdata-datagateway-api-sdk';
import { push } from 'react-router-redux';
import { put, takeLatest } from 'redux-saga/effects';
import { routes } from 'src/constants/routes';
import { storage } from 'src/constants/storage';
import { usersApi } from 'src/services/api';
import { AsyncState, IAction } from '../action';
import { actionTypes, ILoginPayload, loadCurrentUser } from './actions';

function* onLoadCurrentUser() {
  try {
    const sessionID = localStorage.getItem(storage.sessionIdKey);
    const currentUser = yield usersApi.getCurrentUser(sessionID);

    if (!currentUser) {
      throw new PeekdataError('Could not load user', null);
    }

    yield put({
      type: actionTypes.currentUserLoaded,
      payload: {
        data: currentUser,
        isFetching: false,
        error: null,
        errorTimestamp: null,
      },
    });
  } catch (error) {
    localStorage.removeItem(storage.sessionIdKey);

    yield put({
      type: actionTypes.currentUserLoaded,
      payload: {
        data: null,
        isFetching: false,
        error: error.toString(),
        errorTimestamp: new Date(),
      },
    });
  }
}

function* login(action: IAction<ILoginPayload>) {
  try {
    const { userName, password } = action.payload;
    const currentUser = yield usersApi.login(userName, password);

    localStorage.setItem(storage.sessionIdKey, currentUser.sessionID);

    yield put(loadCurrentUser());
    yield put(push(routes.manager));
  } catch (error) {
    yield put({
      type: actionTypes.currentUserLoaded,
      payload: {
        data: null,
        isFetching: false,
        error: error.toString(),
        errorTimestamp: new Date(),
      },
    });
  }
}

function* logout() {
  try {
    const sessionID = localStorage.getItem(storage.sessionIdKey);

    yield usersApi.logout(sessionID);
  } catch (error) {

  } finally {
    yield put({
      type: actionTypes.currentUserLoaded,
      payload: new AsyncState(),
    });

    localStorage.removeItem(storage.sessionIdKey);

    yield put(push(routes.root));
  }
}

export const loginSaga = [
  takeLatest(actionTypes.loadCurrentUser, onLoadCurrentUser),
  takeLatest(actionTypes.logIn, login),
  takeLatest(actionTypes.logOut, logout),
];
